export const CONTACT = {
  phone: "0398424073",
  phoneDisplay: "0398 424 073",
  email: "fastexpress@gmail.com",
};
